import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import type { PlatformBankAccount } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";
import type { PlatformBankAccountForm } from "@/entity/expenseManage/platBankAccount";

export class PlatBankAccountService extends BaseService<
    PlatformBankAccount,
    PlatformBankAccount,
    any,
    PlatformBankAccountForm
> {
    @confirmable("是否提交")
    public async createData(params: PlatformBankAccountForm) {
        await this.service.post(`${this.path}`, params);
    }
    @confirmable({
        msgs: ["是否禁用，禁用后该银行账号不能使用", "是否启用，启用后该银行账号可以使用"]
    })
    public async updateState(id: string | number, state: number) {
        await this.service.put(`${this.path}/update/${id}/${state}`);
    }
    //平台银行账号下拉列表
    public async getByName(params: {
        name?: string;
        state?: number;
        keyWord?: string;
    }): Promise<PlatformBankAccount[]> {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }
    // 平台银行账号下拉列表
    public async bankSelector(params: {
        name?: string;
        state?: number;
        keyWord?: string;
        useTypes?: number[];
    }): Promise<PlatformBankAccount[]> {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }
}

export const platBankAccountService = new PlatBankAccountService("/admin/platform/bank-account", request.service);
